import styled, { css } from 'styled-components';
import { colors } from 'core/theme';

const svgSize = ({iconSize}) => {
  let size;
  switch (iconSize) {
    case 'xlarge':
      size = 3;
    break;
    case 'large':
      size = 2;
      break;
    case 'medium':
      size = 1.5;
      break;
    default:
      size = 1;
  }
  return css`
    width: ${size}em;
    height: ${size}em;
  `;
}

export const StyledIcon = styled.svg`
  display: block;

  & path,
  & polygon {
    fill: currentColor;
  }

  ${svgSize};
`;

export const StyledFileIcon = styled.svg`
  & circle,
  & path,
  & polygon,
  & rect {
    fill: ${colors.hairline};
  }

  path.text,
  .foreground {
    fill: ${colors.background};
  }
`;



// WEBPACK FOOTER //
// ./src/elements/Icon/styled.js